import { render, staticRenderFns } from "./PretrainingLessons.vue?vue&type=template&id=0f75120e&"
import script from "./PretrainingLessons.vue?vue&type=script&lang=js&"
export * from "./PretrainingLessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports